import {
  type LinePlotSettings,
  type WorkspaceLayoutSettings,
} from '../WorkspaceDrawer/Settings/types';
import {useLinePlotTemplateSections} from './runLinePlots/useLinePlotSections';
import {useWorkspaceLayoutTemplateSections} from './workspaceLayout/useWorkspaceLayoutSections';
import {type WorkspaceTemplate} from './workspaceTemplatesQueries';

/**
 * This hook is used in both the template drawer and the user settings page.
 * In both pages, we want to display the same data; however, the template
 * drawer needs to handle strikethrough old values when relevant.
 */
export const useTemplateSections = ({
  workspaceTemplate,
  currWorkspaceLinePlotSettings,
  currWorkspaceLayoutSettings,
}: {
  workspaceTemplate: WorkspaceTemplate;
  currWorkspaceLinePlotSettings?: LinePlotSettings;
  currWorkspaceLayoutSettings?: WorkspaceLayoutSettings;
}) => {
  const linePlotTemplateSections = useLinePlotTemplateSections({
    currTemplateLinePlotSettings: workspaceTemplate?.linePlotSettings,
    currWorkspaceLinePlotSettings,
  });
  const workspaceLayoutTemplateSections = useWorkspaceLayoutTemplateSections({
    currTemplateWorkspaceLayoutSettings:
      workspaceTemplate?.workspaceLayoutSettings,
    currWorkspaceLayoutSettings,
  });

  return {
    linePlotTemplateSections,
    workspaceLayoutTemplateSections,
  };
};
